import React from 'react'

import Skeleton from 'components_new/atoms/Skeleton'

const Loading = () => {
  return <Skeleton height={48} sx={{ my: 2 }} />
}

Loading.displayName = 'Loading'

export default Loading
